import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button } from '@/shared/presentation/components/ui/Button';
import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';

import { CreateUserScreen } from '../CreateUser';
import { InvitationsViewModel } from './Invitations.vm';

export const InvitationsScreen = observer(() => {
  const vm = useViewModel(InvitationsViewModel);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        name: 'Email',
        grow: 2,
        selector: (row) =>
          row.registrationCode ? (
            <Link to={`/admin/accounts/${row.registrationCode}`}>{row.email}</Link>
          ) : (
            row.email
          ),
      },
      {
        name: 'Status',
        selector: (row) => row.status,
      },
      {
        name: 'Escopos',
        selector: (row) => row.scopes.map((scope) => scope.name).join(', ') || '-',
      },
      {
        name: 'Papel',
        selector: (row) => row.role.name,
      },
      {
        name: 'Url de convite',
        selector: (row) => (
          <a
            href={`#`}
            onClick={(e) => {
              e.preventDefault();

              if (!navigator.clipboard) {
                toast.error(
                  'Seu navegador não suporta a funcionalidade de copiar para a área de transferência',
                );
                return;
              }

              navigator.clipboard.writeText(row.inviteUrl);
              toast.success('Link copiado para a área de transferência');
            }}
          >
            Copiar link
          </a>
        ),
      },
    ],
    [],
  );

  const actions = useMemo(() => [], []);

  return (
    <Page
      title="Convites"
      subtitle={`Gerencie os convites enviados`}
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar os convites."
      headerActions={() => (
        <Button
          icon="add"
          size="small"
          disabled={vm.isLoading}
          onClick={() => {
            navigate('/admin/invitations/create');
          }}
        >
          Criar convites
        </Button>
      )}
    >
      <DataTable
        isLoading={vm.isLoading}
        columns={columns}
        data={vm.invitations}
        actions={actions}
        searchPlaceholder="Pesquisar por email"
        paginationServer
        progressPending={vm.isPaginationLoading}
        paginationTotalRows={vm.pagination.totalItems}
        onSearch={(value) =>
          vm.setSearchCriteria({
            email: value?.trim() || '',
          })
        }
        onChangeRowsPerPage={(pageSize) => vm.setPageSize(pageSize)}
        onChangePage={(newPage) => vm.setPage(newPage)}
      />
      <CreateUserScreen />
    </Page>
  );
});
